import type { FoundContactEmailStatus, OutreachEnrollmentStatus } from '@shared/outreach';
import type { FoundContact } from '@/lib/outreach';

/** Words of the sequence page (03/11/2026): short, the state and nothing else. */

export const EMAIL_STATUS_LABELS: Record<FoundContactEmailStatus, string> = {
  valid: 'vérifiée',
  catch_all: 'domaine ouvert',
  risky: 'incertaine',
  invalid: 'invalide',
  manual: 'saisie',
};

export const EMAIL_MISSING_LABELS: Record<NonNullable<FoundContact['emailMissing']>, string> = {
  not_found: 'Introuvable',
  no_provider: 'Aucun fournisseur',
  opposed: 'Refus de contact',
};

export const ENROLLMENT_LABELS: Record<OutreachEnrollmentStatus, string> = {
  drafting: 'Écriture…',
  review: 'À relire',
  active: 'En cours',
  replied: 'A répondu',
  bounced: 'Adresse en erreur',
  opted_out: 'Refus',
  stopped: 'Arrêtée',
  finished: 'Terminée',
  failed: 'Échec',
};

export const ORIGIN_LABELS: Record<FoundContact['origin'], string> = {
  crm: 'CRM',
  dossier: 'Ce qu’on sait',
  web: 'Web',
  manual: 'Ajoutée',
};

export const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const formatWhen = (iso: string | null): string => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};
